import { components, SingleValueProps } from 'react-select';
import { GenericDropdownOption } from 'App.types';
import { creatorbase, InvoiceRequestStatus } from '@round/api';
import React from 'react';
import FinanceStatusBadge from './FinanceStatusBadge';

type Props = SingleValueProps<GenericDropdownOption<creatorbase.FinanceStatus>>;

const FinanceStatusBadgeValue = (props: Props) => {
    return (
        <components.SingleValue {...props}>
            <FinanceStatusBadge financeStatus={props.data.value} />
        </components.SingleValue>
    );
};

export default FinanceStatusBadgeValue;
